import React from "react";
import { getImgPath } from "../common/helper";

import {
  t,
  IF_HEADING1,
  IF_HEADING2,
  IF_P1,
  IF_HEADING3,
  IF_LI1,
  IF_LI2,
  IF_LI3,
  IF_LI4,
  IF_LI5,
  IF_LI6,
  IF_LI7,
  IF_LI8,
  IF_LI9,
  IF_LI10,
  IF_LI11,
  IF_LI12,
  IF_LI13,
  IF_LI14,
  IF_LI15,
  IF_LI16,
  IF_LI17,
  IF_LI18,
  IF_LI19,
} from "../../translations/AboutUs/InfrastructureFacility";

function InfrastructureFacility() {
  return (
    <div
      style={{
        width: "80%",
        display: "flex",
        alignItems: "flex-start",
        justifyContent: "flex-start",
        flexDirection: "column",
        gap: 15,
        paddingRight: 10,
      }}
    >
      <div className="a-large" style={{ fontWeight: 500, textAlign: "left" }}>
        {t(IF_HEADING1)}
      </div>
      <div className="a-large" style={{ fontWeight: 500, textAlign: "left" }}>
        {t(IF_HEADING2)}
      </div>
      <div
        className="a-regular"
        style={{
          fontWeight: 400,
          color: "#444444",
          textAlign: "justify",
          paddingBottom: 15,
        }}
      >
        {t(IF_P1)}
      </div>
      <div style={{ display: "flex", gap: 10, flexWrap: "wrap" }}>
        <div>
          <img
            src={getImgPath(
              "/img/aboutus/KSRTC Corporate Office, Bangalore.png"
            )}
            alt=""
          />
        </div>
        <div>
          <img
            src={getImgPath(
              "/img/aboutus/KSRTC Regional Training Institute, Hassan.png"
            )}
            alt=""
          />
        </div>
        <div>
          <img src={getImgPath("/img/aboutus/KSRTC bus station1.png")} alt="" />
        </div>
        <div>
          <img src={getImgPath("/img/aboutus/KSRTC bus station.png")} alt="" />
        </div>
        <div>
          <img src={getImgPath("/img/aboutus/KSRTC Bus Station2.png")} alt="" />
        </div>
        <div>
          <img
            src={getImgPath(
              "/img/aboutus/KSRTC City Bus Station at Mysore.png"
            )}
            alt=""
          />
        </div>
        <div>
          <img
            src={getImgPath("/img/aboutus/KSRTC Bus Depot at Magadi.png")}
            alt=""
          />
        </div>
        <div>
          <img
            src={getImgPath(
              "/img/aboutus/KSRTC Sanitary Block at Bus Station.png"
            )}
            alt=""
          />
        </div>
      </div>
      <div className="a-normal" style={{ fontWeight: 500, textAlign: "left" }}>
        {t(IF_HEADING3)}
      </div>
      <ul style={{ margin: 0, padding: 0, paddingLeft: 30 }}>
        <li className="a-regular" style={{ fontWeight: 400 }}>{t(IF_LI1)}</li>
        <li className="a-regular" style={{ fontWeight: 400 }}>{t(IF_LI2)}</li>
        <li className="a-regular" style={{ fontWeight: 400 }}>{t(IF_LI3)}</li>
        <li className="a-regular" style={{ fontWeight: 400 }}>{t(IF_LI4)}</li>
        <li className="a-regular" style={{ fontWeight: 400 }}>{t(IF_LI5)}</li>
        <li className="a-regular" style={{ fontWeight: 400 }}>{t(IF_LI6)}</li>
        <li className="a-regular" style={{ fontWeight: 400 }}>{t(IF_LI7)}</li>
        <li className="a-regular" style={{ fontWeight: 400 }}>{t(IF_LI8)}</li>
        <li className="a-regular" style={{ fontWeight: 400 }}>{t(IF_LI9)}</li>
        <li className="a-regular" style={{ fontWeight: 400 }}>{t(IF_LI10)}</li>
        <li className="a-regular" style={{ fontWeight: 400 }}>{t(IF_LI11)}</li>
        <li className="a-regular" style={{ fontWeight: 400 }}>{t(IF_LI12)}</li>
        <li className="a-regular" style={{ fontWeight: 400 }}>{t(IF_LI13)}</li>
        <li className="a-regular" style={{ fontWeight: 400 }}>{t(IF_LI14)}</li>
        <li className="a-regular" style={{ fontWeight: 400 }}>{t(IF_LI15)}</li>
        <li className="a-regular" style={{ fontWeight: 400 }}>{t(IF_LI16)}</li>
        <li className="a-regular" style={{ fontWeight: 400 }}> {t(IF_LI17)}</li>
        <li className="a-regular" style={{ fontWeight: 400 }}>{t(IF_LI18)}</li>
        <li className="a-regular" style={{ fontWeight: 400 }}> {t(IF_LI19)}</li>
      </ul>
    </div>
  );
}

export default InfrastructureFacility;
